// START_MODULE community_statistics
// START_CONTRACT
// PURPOSE: Present a compact, conservative snapshot of Tomsk Data Science activity.
// OPERATIONAL_CONTEXT: Blue statistics band on the public landing page.
// CONTRACT: Use rounded figures supported by public channel history
// or operator-maintained evidence.
// KEYWORDS: statistics, telegram, meetings, attendance
// COMPLEXITY: 2
// END_CONTRACT
import React from 'react';

import StatisticItem from './components/statisticItem/StatisticItem';
import { StatisticsSectionContainer } from './styled';

import MeetingIcon from 'components/atoms/icons/MeetingIcon';
import TelegramIcon from 'components/atoms/icons/TelegramIcon';

import { Section } from 'routes/section';

const Statistics: React.FC = () => (
  <StatisticsSectionContainer id={Section.STATISTICS}>
    <StatisticItem title="Подписчиков в Telegram" number={300} prefix=">">
      <TelegramIcon color="white" size={60} />
    </StatisticItem>
    <StatisticItem title="Проведено встреч" number={40} prefix=">">
      <MeetingIcon color="white" size={60} />
    </StatisticItem>
    <StatisticItem title="В среднем участников на встрече" number={13} prefix=">">
      <MeetingIcon color="white" size={60} />
    </StatisticItem>
  </StatisticsSectionContainer>
);

export default Statistics;
// END_MODULE community_statistics
